module.exports = __webpack_public_path__ + "static/media/progress_bar_1_active.40b73e21.svg";